import {Guidex} from '@/components/Guidex'
import {ROUTES} from '@/config/constants'
// import {AuthContext} from '@/helpers/Auth/AuthProvider'
import {UserRoleContext, UserRoleProvider} from '@/helpers/UserRole/UserRoleProvider'
import {useAuth} from '@/hooks/useAuth'
import {Template} from '@/pages/Template'
import {useAppSelector} from '@/store'
import {selectShellActive} from '@/store/slices/commonSlice'
import {useContext, useEffect} from 'react'
import {Outlet, useNavigate} from 'react-router-dom'

export const ProtectedRoutes = () => {
  return (
    <UserRoleProvider>
      <Template>
        <ProtectedRoutesContent />
      </Template>
    </UserRoleProvider>
  )
}

const ProtectedRoutesContent = () => {
  const {isAuthenticated, signInWithRedirect, inProgress, isCypress} = useAuth()
  const {isAuthorized, isReady: isUserRoleReady, error: userRoleError} = useContext(UserRoleContext)
  const navigate = useNavigate()
  const shellActive = useAppSelector(selectShellActive)
  const shellAuthenticated = shellActive && localStorage.getItem('msalAccessToken')

  useEffect(() => {
    if (shellAuthenticated) {
      return
    }
    if (!isCypress && !isAuthenticated && inProgress === 'none') {
      signInWithRedirect()
      // navigate(ROUTES.LOGIN)
      return
    }

    if (userRoleError) {
      navigate(ROUTES.ERROR_500)
      return
    }

    if (isUserRoleReady && !isAuthorized) {
      navigate(ROUTES.ERROR_403)
    }
  }, [
    isAuthenticated,
    isAuthorized,
    isUserRoleReady,
    navigate,
    userRoleError,
    signInWithRedirect,
    inProgress,
    isCypress,
    shellAuthenticated,
  ])

  useEffect(() => {
    if (isAuthenticated) {
      const preLoginPath = localStorage.getItem('preLoginPath')
      if (preLoginPath) {
        localStorage.removeItem('preLoginPath')
        navigate(preLoginPath)
      }
    }
  }, [isAuthenticated, navigate, isCypress])

  const canRenderRoute = isCypress || (isAuthenticated && isAuthorized) || shellAuthenticated

  return canRenderRoute ? (
    <Guidex>
      <Outlet />
    </Guidex>
  ) : null
}
